import { Ass_03, Lia_03 } from "../../Chart.js";
import { NewEntry } from "../../entry/NewEntry.js";
import { Template } from "../../template/Template.js";
import { findVariableValue } from "../../template/findVariableValue.js";

export const DIVIDENDS: Template = {
  id: "f4d49f59-834e-44b6-a784-82bb27995d9e",
  name: "Dividendi väljamaksmine",
  variables: [
    {
      name: "Date",
      type: "date"
    },
    {
      name: "Amount",
      type: "amount_eur"
    }
  ],
  initialValues: [
    {
      name: "Amount",
      value: "1000"
    }
  ],
  generate: (values) => {
    const date = findVariableValue("Date", values);
    const amount = Math.round(parseFloat(findVariableValue("Amount", values)) * 100);

    const entry: NewEntry = {
      title: "Dividendi väljamaksmine",
      items: [
        {
          title: "Dividendi väljamaksmine",
          date: date,
          amount: amount,
          eurAmount: amount,
          currency: "eur",
          debit: Lia_03,
          credit: Ass_03
        }
      ]
    };

    return { type: "success", entry };
  }
};
